module.exports = kolibriCoreAppGlobal.coreVue.components.PrivacyInfoModal;